import { buildTour } from '@epc/contracts';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { Link } from '@tanstack/react-router';
import { useEffect, useMemo, useState } from 'react';
import { api } from '../lib/api';
import { useMe } from '../lib/session';
import { supportUi, useSupportUi } from '../lib/support';
import { Button } from '../ui/button';
import { Dialog } from '../ui/dialog';

/**
 * Экскурсия по разделам роли (БЗ-03): при первом входе и по кнопке в меню. Шаги собираются из прав человека, как
 * инструкция по роли: человек видит только свои разделы. Пройти или пропустить — отмечается на сервере, чтобы
 * экскурсия не возвращалась на другом устройстве.
 */
export function Tour() {
  const { tour } = useSupportUi();
  const me = useMe();
  const qc = useQueryClient();
  const steps = useMemo(() => buildTour(me.access), [me.access]);
  const [i, setI] = useState(0);
  const done = useMutation({
    mutationFn: () => api('/support/tour/done', { method: 'POST' }),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['support', 'me'] }),
  });
  useEffect(() => {
    if (tour) setI(0);
  }, [tour]);

  function close() {
    supportUi.closeTour();
    if (me.tenant?.staff) done.mutate();
  }

  const step = steps[Math.min(i, steps.length - 1)]!;
  const last = i >= steps.length - 1;
  return (
    <Dialog
      open={tour}
      onOpenChange={(v) => {
        if (!v) close();
      }}
      title={step.title}
      description={`Шаг ${i + 1} из ${steps.length}`}
      width="sm"
      footer={
        <>
          <Button variant="ghost" onClick={close}>
            {last ? 'Закрыть' : 'Пропустить'}
          </Button>
          {i > 0 ? <Button onClick={() => setI(i - 1)}>Назад</Button> : null}
          {last ? (
            <Button variant="primary" onClick={close}>
              Готово
            </Button>
          ) : (
            <Button variant="primary" onClick={() => setI(i + 1)}>
              Дальше
            </Button>
          )}
        </>
      }
    >
      <p className="text-[14px] leading-6 text-ink">{step.text}</p>
      {step.path ? (
        <Link
          to={step.path}
          onClick={close}
          className="mt-3 inline-flex h-11 items-center rounded-md border border-line px-3 text-[14px] font-medium hover:border-ink-3"
        >
          Открыть раздел
        </Link>
      ) : null}
    </Dialog>
  );
}
